import { render, staticRenderFns } from "./TagsCombo.vue?vue&type=template&id=d057e4da"
import script from "./TagsCombo.vue?vue&type=script&lang=js"
export * from "./TagsCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports